var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(-1244 -4941)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1166",
    "data-name": "Rectangle 1166",
    width: 77,
    height: 77,
    transform: "translate(1244 4941)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Utility",
    transform: "translate(1252 4949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M26.191,40.827c0-2.914,1.557-5.624,5.37-6.644S71.835,25,71.835,25a5.323,5.323,0,0,1,5.37,5.276V69.842a5.323,5.323,0,0,1-5.37,5.276L31.561,83.031c-2.966,2.638-5.37.276-5.37-2.638Z",
    transform: "translate(-25.956 -25)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M26,39.519a6.152,6.152,0,0,1,6.152-6.152h44.3A6.152,6.152,0,0,1,82.6,39.519V77.664a6.152,6.152,0,0,1-6.152,6.152h-44.3A6.152,6.152,0,0,1,26,77.664Z",
    transform: "translate(-26 -23.072)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M49,50.519a6.152,6.152,0,0,1,6.152-6.152H74.84a6.152,6.152,0,0,1,6.152,6.152v9.844a6.152,6.152,0,0,1-6.152,6.152H55.152A6.152,6.152,0,0,1,49,60.363Z",
    transform: "translate(-20.699 -20.537)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M62.545,54.448a4.081,4.081,0,1,1-4.081-4.081A4.081,4.081,0,0,1,62.545,54.448Z",
    transform: "translate(-19.458 -19.154)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility);
export default __webpack_public_path__ + "static/media/Utility.df9001efa623aabfde6004f24d850778.svg";
export { ForwardRef as ReactComponent };